import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(['addToCart', 'removeFromCart'])
  }
}